import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "ssuq_admin_token";
const CLIENT_TOKEN_KEY = "ssuq_client_token";

export const setAdminToken = (t) => sessionStorage.setItem(TOKEN_KEY, t);
export const clearAdminToken = () => sessionStorage.removeItem(TOKEN_KEY);
export const getAdminToken = () => sessionStorage.getItem(TOKEN_KEY);

export const setClientToken = (t) => localStorage.setItem(CLIENT_TOKEN_KEY, t);
export const clearClientToken = () => localStorage.removeItem(CLIENT_TOKEN_KEY);
export const getClientToken = () => localStorage.getItem(CLIENT_TOKEN_KEY);

// Attach admin JWT (priority) or client JWT to every request when present
axios.interceptors.request.use((config) => {
  const t = getAdminToken() || getClientToken();
  if (t) config.headers = { ...config.headers, Authorization: `Bearer ${t}` };
  return config;
});

// On 401, clear session and force re-login on admin area
axios.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error?.response?.status === 401) {
      clearAdminToken();
      sessionStorage.removeItem("ssuq_admin");
      if (window.location.pathname.startsWith("/admin")) {
        sessionStorage.setItem("ssuq_session_expired", "1");
        window.location.reload();
      }
    }
    return Promise.reject(error);
  }
);

export const api = {
  createClient: (d) => axios.post(`${API}/clients`, d).then((r) => r.data),
  createVendor: (d) => axios.post(`${API}/vendors`, d).then((r) => r.data),
  createOrder: (items, customer, paymentMethod) => axios.post(`${API}/orders`, { items, customer, paymentMethod }).then((r) => r.data),
  getClients: () => axios.get(`${API}/clients`).then((r) => r.data),
  getVendors: () => axios.get(`${API}/vendors`).then((r) => r.data),
  getOrders: () => axios.get(`${API}/orders`).then((r) => r.data),
  getPurchaseOrders: () => axios.get(`${API}/purchase-orders`).then((r) => r.data),
  getStats: () => axios.get(`${API}/stats`).then((r) => r.data),
  approveVendor: (id) => axios.patch(`${API}/vendors/${id}`, { status: "approuvé" }).then((r) => r.data),
  setOrderStatus: (id, status) => axios.patch(`${API}/orders/${id}`, { status }).then((r) => r.data),
  setPoStatus: (id, status) => axios.patch(`${API}/purchase-orders/${id}`, { status }).then((r) => r.data),
  del: (type, id) => axios.delete(`${API}/${type}/${id}`).then((r) => r.data),
  adminLogin: (code) => axios.post(`${API}/admin/login`, { code }).then((r) => r.data),
  aiChat: (message, session_id) => axios.post(`${API}/ai/chat`, { message, session_id }).then((r) => r.data),
  getSuppliers: () => axios.get(`${API}/suppliers`).then((r) => r.data),
  createSupplier: (d) => axios.post(`${API}/suppliers`, d).then((r) => r.data),
  updateSupplier: (id, d) => axios.patch(`${API}/suppliers/${id}`, d).then((r) => r.data),
  getCustomProducts: () => axios.get(`${API}/products-custom`).then((r) => r.data),
  createProduct: (d) => axios.post(`${API}/products-custom`, d).then((r) => r.data),
  importProducts: (file) => { const fd = new FormData(); fd.append("file", file); return axios.post(`${API}/products-custom/import`, fd).then((r) => r.data); },
  updateProduct: (id, data) => axios.patch(`${API}/products-custom/${id}`, data).then((r) => r.data),
  downloadTemplate: () => axios.get(`${API}/products-custom/template`, { responseType: "blob" }).then((r) => r.data),
  uploadProductImage: (file) => { const fd = new FormData(); fd.append("file", file); return axios.post(`${API}/upload/product-image`, fd).then((r) => r.data); },
  uploadBannerVideo: (file) => { const fd = new FormData(); fd.append("file", file); return axios.post(`${API}/upload/banner-video`, fd).then((r) => r.data); },
  validateClient: (id) => axios.patch(`${API}/clients/${id}/validate`).then((r) => r.data),
  clientLogin: (email, code) => axios.post(`${API}/client/login`, { email, code }).then((r) => r.data),
  forgotCode: (email) => axios.post(`${API}/client/forgot-code`, { email }).then((r) => r.data),
  getClientOrders: () => axios.get(`${API}/client/orders`).then((r) => r.data),
  getInvoice: (id) => axios.get(`${API}/purchase-orders/${id}/invoice`, { responseType: "blob" }).then((r) => r.data),
  getAllInvoices: () => axios.get(`${API}/client/invoices`, { responseType: "blob" }).then((r) => r.data),
  getPublicBC: (id) => axios.get(`${API}/purchase-orders/${id}/public`).then((r) => r.data),
  confirmBC: (id, status) => axios.patch(`${API}/purchase-orders/${id}/confirm`, { status }).then((r) => r.data),
  getBanners: () => axios.get(`${API}/banners`).then((r) => r.data),
  getIntro: () => axios.get(`${API}/settings/intro`).then((r) => r.data),
  setIntro: (d) => axios.put(`${API}/settings/intro`, d).then((r) => r.data),
  getAllBanners: () => axios.get(`${API}/admin/banners`).then((r) => r.data),
  createBanner: (d) => axios.post(`${API}/banners`, d).then((r) => r.data),
  updateBanner: (id, d) => axios.patch(`${API}/banners/${id}`, d).then((r) => r.data),
  deleteBanner: (id) => axios.delete(`${API}/banners/${id}`).then((r) => r.data)
};
